import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
export var usePortalRootInstance = function usePortalRootInstance(id) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    domNode = _useState2[0],
    setNode = _useState2[1];
  var handleMount = useCallback(function (geoObject) {
    if (geoObject) geoObject.balloon.open();
    /** one tick delay is needed for ymaps to render node to the dom */
    setTimeout(function () {
      setNode(geoObject ? document.getElementById(id) : null);
    });
  }, [id]);
  return [domNode, handleMount];
};